/* eslint-disable jsx-a11y/anchor-has-content */
import { useState, useEffect } from "react";
import { Spin } from "antd";
import DocUploadDropZone from "../UploadZone";
import { Trans, useTranslation } from "react-i18next";
import { fetchUploadedDocuments } from "../../../api/api";
import { Button } from "../../styles/Button.styled";
import PlanSummaryCard from "../../cards/PlanSummaryCard";
import { PlanSavingsCard } from "../../cards/PlanSavingsCard";
import { getEnrollmentRecord } from "../../../api/enrollment";
import {
  EnrollmentAside,
  EnrollmentContainer,
  EnrollmentMain,
  EnrollmentResultContent,
} from "../../styles/Enrollment.styled";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router";
import DepositAlternative from "../../depositWaiver/DepositAlternative";

export const docUploadStyles = {
  width: "100%",
  padding: 30,
  backgroundColor: "#EFF7FA",
  borderRadius: 12,
  marginTop: "40px",
};

const DocUploadScreen = () => {
  const { t, i18n } = useTranslation("enrollment");
  const { t: tCommon } = useTranslation("common");
  const navigate = useNavigate();

  const url = new URL(window.location.href);
  const idParam = url.searchParams.get("id");
  const signParam = url.searchParams.get("sign");
  const doc_type = url.searchParams.get("doc_type");

  const [loading, setLoading] = useState<boolean>(false);
  const [uploadComplete, setUploadComplete] = useState<boolean>(false);
  const [userData, setUserData] = useState<any>(null);
  // const [cancelled, setCancelled] = useState(false);

  const fetchDocs = async () => {
    setLoading(true);
    try {
      const res = await fetchUploadedDocuments(idParam, signParam);
      if (res.status === 200 && res.files.length > 0) {
        setUploadComplete(true);
      }
    } catch (err) {
      setUploadComplete(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!idParam || !signParam) return;
    const getUserData = async () => {
      const response = await getEnrollmentRecord(idParam, signParam);
      setUserData(response?.data?.record || null);
    };

    getUserData();
  }, [idParam, signParam]);

  const renderUploadContent = () => {
    if (loading) {
      return <Spin tip="Loading..." />;
    }
    if (uploadComplete) {
      return (
        <p style={{ color: "green", textAlign: "center" }}>
          {tCommon("thankYouText")}
        </p>
      );
    }
    return (
      <DocUploadDropZone
        fetchDocs={fetchDocs}
        docFor={doc_type || "automation"}
        // setCancelled={setCancelled}
        payDepositButton={
          doc_type === "waiver"
            ? () => (
                <Button>
                  <span
                    onClick={() => {
                      navigate(`/confirmation?id=${idParam}&sign=${signParam}`);
                    }}
                  >
                    {t("Pay Deposit")}
                  </span>
                </Button>
              )
            : false
        }
      />
    );
  };

  return (
    <Container>
      <div className="documentContainer">
        <EnrollmentContainer>
          <EnrollmentMain>
            <EnrollmentResultContent>
              <div className="text-center">
                <h1 className="mb-3 text-center">
                  {t("We are Almost There!")}
                </h1>
                {doc_type === "waiver"
                  ? renderWaiverContent(t)
                  : renderWhiteListContent(t)}
                <div className="text-center">
                  <div style={docUploadStyles}>{renderUploadContent()}</div>
                  <div className="mt-5">
                    <Button
                      withArrow
                      onClick={() => {
                        window.location.href =
                          i18n.language === "en"
                            ? `https://cleanskyenergy.com/`
                            : `https://cleanskyenergy.com/es`;
                      }}
                    >
                      {t("Back to Homepage")}
                    </Button>
                  </div>
                </div>
              </div>
            </EnrollmentResultContent>
          </EnrollmentMain>
          <EnrollmentAside>
            <PlanSavingsCard
              utilityId={userData?.plan && JSON.parse(userData.plan).id_utility}
              plan={userData?.plan && JSON.parse(userData?.plan)}
            />
            <PlanSummaryCard
              selectedPlan={userData?.plan && JSON.parse(userData?.plan)}
              promocode={userData?.promo_code || ""}
            />
          </EnrollmentAside>
        </EnrollmentContainer>
      </div>
    </Container>
  );
};

export default DocUploadScreen;

const renderWhiteListContent = (t: any) => (
  <>
    <b style={{ fontSize: "1rem", textAlign: "center" }}>
      {t(
        "Your application for service with CleanSky Energy has been placed on hold, pending verification of your information."
      )}
    </b>
    <b style={{ fontSize: "1rem" }}>
      {t(
        "Your service will not start until such time as your information can be validated."
      )}
    </b>
    <p>
      <div
        style={{
          textAlign: "left",
          fontSize: "16px",
          marginTop: "10px",
        }}
      >
        <Trans i18nKey="enrollment:fraudVerbiage2611_04"></Trans>
      </div>
      <div
        style={{
          textAlign: "left",
          marginLeft: "10px",
          marginTop: "10px",
          fontSize: "16px",
        }}
      >
        <ul>
          <li>
            <Trans i18nKey="enrollment:fvdoc1">
              • A driver's license or state identification certificate issued by
              a state or territory of the United States.
            </Trans>
          </li>
          <li>
            <Trans i18nKey="enrollment:fvdoc2">
              • United States or foreign passport.
            </Trans>
          </li>
          <li>
            <Trans i18nKey="enrollment:fvdoc3">
              • U.S. military identification card.
            </Trans>
          </li>
          <li>
            <Trans i18nKey="enrollment:fvdoc4">
              • U.S. Department of Homeland Security identification document.
            </Trans>
          </li>
          <li>
            <Trans i18nKey="enrollment:fvdoc5">
              • U.S. Citizenship and Immigration Services identification
              document.
            </Trans>
          </li>
          <li>
            <Trans i18nKey="enrollment:fvdoc6">
              • U.S. Department of State identification document.
            </Trans>
          </li>
        </ul>
      </div>
    </p>
  </>
);

const renderWaiverContent = (t: any) => (
  <>
    <p style={{ fontSize: 16, fontWeight: "bold", textAlign: "center" }}>
      {t("depositWaiverDocTitle")}
    </p>
    <span
      className="upload-files-sublabel"
      style={{ textAlign: "left", fontSize: 15 }}
    >
      <DepositAlternative />
    </span>
  </>
);
